<template>
    <a-list item-layout="horizontal" :split="false" :data-source="resultInfoArr" :class="containerStyle">
      <a-list-item slot="renderItem" slot-scope="item,index">
        <a-list-item-meta :description="item.value">
          <span slot="title" class="title_font_Weight">
            {{ item.label }}
            <a-popover v-if="index === 3" 
                       trigger="click" 
                       placement="topLeft" 
                       overlayClassName="popover_container">
              <template slot="content">
                <span>納管碼為裝載至車輛上之聯網裝置開通後，產生一可供車隊納管之一串數字。</span>
              </template>
              <a href="#" @click.prevent>
                <a-icon type="question-circle" style="color: #638D0A" />
                說明
              </a>
            </a-popover>
          </span>
        </a-list-item-meta>
        <a-button v-if="index === 3" class="send_code_btn" @click="showModal">
          <a-icon type="mail" :style="{ fontSize: '16px' }" />
          寄送至手機
        </a-button>
        <a-modal 
        v-model="visible" 
        title="寄送成功" 
        ok-text="確定 " 
        cancel-text=" " 
        @ok="hideModal"
        :maskClosable="false"
        :closable="false"
        :centered="true"
        :maskStyle="{background: 'rgba(0, 0, 0, 0.1)'}"
        dialogClass="msg_success_modal">
          <p>納管碼已發送至{{phone}}</p>
        </a-modal>        
      </a-list-item>
    </a-list>
</template>

<script>
  export default {
      data() {
        return {
          resultInfoArr: [
            { id: '', label: '姓名', value: '王曉明' },
            { label: '車號', value: 'KLA-4561' },
            { label: '手機號碼', value: '0900-123-456' },
            { label: '納管碼', value: 'SAF*******123' },
            { label: '服務開通日', value: '2021年09月13日' },
            { label: '服務到期日', value: '2024年09月13日' },
          ],
          currentPath: '/',
          visible: false,
        }
      },
      mounted () {
          this.currentPath = this.$route.path;
      },
      methods: {
        showModal() {
          this.visible = true;
        },
        hideModal() {
          this.visible = false;
        },
      },
      computed: {
          containerStyle: function() {
              return this.currentPath === '/individual/deviceInfo' ? 'individual_result_container' : '';
          },
          phone: function() {
            return this.resultInfoArr.filter(item => item.label === '手機號碼')[0].value;
          }
      },     
      watch: {
          $route: function() {
          console.log('this.$route', this);
          this.currentPath = this.$route.path;
          },
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";

  .ant-list-item {
    padding: 0px 0 12px 0;
    align-items: flex-end;
    .ant-list-item-meta-title {
      line-height: 24px;
      color: #343741;
      a {
        color: #638D0A;
        margin-left: 14px;
        font-weight: 400;
      }
    }
    .ant-list-item-meta-description {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      color: #000000;
    }
  }

  .send_code_btn {
    background-color: #C0E560;
    padding: 7px 12px;
    border-radius: 8px;
    box-shadow: none;
    border: none;
    color: #1E475D;
  }

  .individual_result_container {
    padding: 0 13px;
  }

</style>